// src/api/requestIssuanceApi.js
import apiClient from "./axios";

const requestIssuanceApi = {
  // GET all with pagination + search
  getAll: async (page = 1, pageSize = 10, search = "") => {
    const response = await apiClient.get("/requests/", {
      params: { page, page_size: pageSize, search: search.trim() || undefined },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post("/requests/", data);
    return response.data;
  },

  // UPDATE (PATCH)
  update: async (id, data) => {
    const response = await apiClient.patch(`/requests/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/requests/${id}/`);
    return id;
  },

  // MARK AS IN PROGRESS
  // markInProgress: async (id) => {
  //   const response = await apiClient.post(`/requests/${id}/in-progress/`);
  //   return response.data;
  // },

  // src/api/requestIssuanceApi.js

markInProgress: async (id, expected_completion_datetime = null) => {
  const payload = {};
  if (expected_completion_datetime) {
    payload.expected_completion_datetime = expected_completion_datetime;
  }
  const response = await apiClient.post(`/requests/${id}/in-progress/`, payload);
  return response.data;
},

  // APPROVE
  approve: async (id, items) => {
    const response = await apiClient.post(`/requests/${id}/approve/`, {
      items,
    });
    return response.data;
  },

  // REJECT
  reject: async (id, reason) => {
    const response = await apiClient.post(`/requests/${id}/reject/`, {
      reason,
    });
    return response.data;
  },

  // acknowledge
  acknowledge: async (id, data) => {
    await apiClient.post(`/requests/${id}/acknowledge/`, data);
  },

  // EXPORT CSV
  exportCsv: async () => {
    const response = await apiClient.get("/requests/export/", {
      responseType: "blob",
    });
    return response.data;
  },
};

export default requestIssuanceApi;
